import { BadgeProps } from '@/components/ui/badge'
import { User, UserStatus } from '@/domain/auth/auth'
import { BasicFilters } from '..'
import { IvaCondition } from '../invoices/invoice'
import { DocType } from '../shared'
export { DocType, IvaCondition }

export enum Genre {
  M = 'Masculino',
  F = 'Femenino',
  X = 'No definido',
}

export const getGenreOptions = () => Object.entries(Genre).map(([value, label]) => ({ value, label, }))

export enum UserRelationship {
  CONYUGE = 'Cónyuge',
  HIJO = 'Hijo',
  PADRE = 'Padre',
  HERMANO = 'Hermano',
  ABUELO = 'Abuelo',
  NIETO = 'Nieto',
  TIO = 'Tío',
  SOBRINO = 'Sobrino',
  OTRO = 'Otro'
}

export const getUserRelationshipOptions = () => Object.entries(UserRelationship).map(([value, label]) => ({ value, label, }))

export interface UserContactInfo {
  id: string
  name?: string
  code: number
  genre?: string
  dateOfBirth?: Date
  relationship?: string
  phone?: string
  email?: string
  street?: string
  city?: string
  zipCode?: string
  state?: string
  country?: string
  observations?: string
}

export interface UserData {
  id: string
  userId: string
  legalName: string
  code: number
  genre?: string
  docType: DocType
  docNumber: string
  dateOfBirth?: Date
  phone?: string
  email?: string
  street?: string
  city?: string
  zipCode?: string
  state?: string
  country?: string
  address?: string
  observations?: string
  invoiceLegalName?: string
  invoiceDocType?: DocType
  invoiceDocNumber?: string
  invoiceAddress?: string
  ivaCondition?: IvaCondition
  paidByUserId?: string
}

export interface ClientData {
  id: string
  userId: string
  address?: string
  contactPhone?: string
  referenceContact1Phone?: string
  referenceContact2Phone?: string
  referenceContact1Name?: string
  referenceContact2Name?: string
  referenceContact1Relationship?: string
  referenceContact2Relationship?: string
  referenceContact1Email?: string
  referenceContact2Email?: string
  isOverdue: boolean
  isBlacklisted: boolean
  createdAt: string
  updatedAt: string
}

export interface ClientDetail extends User {
  userData: UserData
  reference1?: UserContactInfo
  reference2?: UserContactInfo
}

export interface ClientSummary {
  id: string
  email: string
  name: string
  code: number
  status: UserStatus
  address: string
  balance: number
  contractsCount: number
  paidByName?: string
  referenceContacts?: string
}

export interface UpdateClientData {
  email?: string
  status?: UserStatus
  userData?: Partial<UserData>
  reference1?: Partial<UserContactInfo>
  reference2?: Partial<UserContactInfo>
}

export interface ClientFilters extends BasicFilters {
  includeDetails?: boolean
  status?: UserStatus
}

export const getClientFullName = (client: ClientSummary): string => {
  return `${client.name}`.trim() || client.email
}

export const isClientActive = (client: ClientSummary): boolean => {
  return client.status === UserStatus.Active
}

export const formatClientStatus = (status: UserStatus): string => {
  const statuses: Record<UserStatus, string> = {
    [UserStatus.Pending]: 'Pendiente',
    [UserStatus.Active]: 'Activo',
    [UserStatus.Suspended]: 'Moroso',
    [UserStatus.Inactive]: 'Inactivo',
  }
  return statuses[status] || status
}

export const getClientStatusColor = (status: UserStatus): string => {
  switch (status) {
    case UserStatus.Pending:
      return 'bg-yellow-300 text-yellow-800 hover:bg-yellow-300'
    case UserStatus.Active:
      return 'bg-green-100 text-green-800 hover:bg-green-100'
    case UserStatus.Suspended:
      return 'bg-red-100 text-red-800 hover:bg-red-100'
    case UserStatus.Inactive:
      return 'bg-orange-100 text-orange-800 hover:bg-orange-100'
    default:
      return 'bg-gray-100 text-gray-800 hover:bg-gray-100'
  }
}
